import { App } from "vue";
import {
  Button,
  Form,
  Field,
  Cell,
  CellGroup,
  Uploader,
  Notify,
  Image,
  NavBar,
  RollingText,
  Empty,
  BackTop,
  PullRefresh,
  Divider,
  Dialog,
  Overlay,
  Loading,
  Tag,
  Search,
  PickerGroup,
} from "vant";
import "vant/es/notify/style";
import "vant/es/dialog/style";
import "vant/es/image-preview/style";
import "vant/es/toast/style";
const Vant = {
  install: (app: App): void => {
    app.use(Button);
    app.use(Form);
    app.use(Field);
    app.use(Cell);
    app.use(CellGroup);
    app.use(Uploader);
    app.use(Notify);
    app.use(Image);
    app.use(NavBar);
    app.use(RollingText);
    app.use(Empty);
    app.use(BackTop);
    app.use(PullRefresh);
    app.use(Divider);
    app.use(Dialog);
    app.use(Overlay);
    app.use(Loading);
    app.use(Tag);
    app.use(Search);
    app.use(PickerGroup);
  },
};
export default Vant;
